import { useContext } from "react"
import { NavigationContext } from "../context/navigationContext.ts"

export function useNavigationContext() {
  return useContext(NavigationContext)
}
